export * from "./accommodation-banner";
